var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/01705db87465a5a38681d7f9e5f3cd9b.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/083db03767fe43fdd9fc684a690e9752.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c44ba76e7fd55be0e92765081ad3035.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b75b346c7c45f41306aadd49beb945c.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4f4f144cf08d2625a3b9fe349b87dc26.js').default;
var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54f7739d71fd0e6bee2e907696b9c9a0.js').default;
var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/58c4fecad22c06c30e2e9679911f272f.js').default;
var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78ae2de9601b8b1f3902c963f1467798.js').default;
var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96e9f8ece4364929c46d03b3ec4b9995.js').default;
var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99ba94413c4db874cf3ccb2032d49ad8.js').default;
var scope_11 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e10164c9b177276825814b07c241e7ca.js').default;
var scope_12 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f1afb84da8381a294ef847d2989f8e7c.js').default;
var scope_14 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;
var scope_15 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/faed81c7ef1028e991226f38536540b4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15 )
    